import { render, staticRenderFns } from "./access-control-badge-table-input.vue?vue&type=template&id=2c5074b4&scoped=true&"
import script from "./access-control-badge-table-input.ts?vue&type=script&lang=ts&"
export * from "./access-control-badge-table-input.ts?vue&type=script&lang=ts&"
import style0 from "./access-control-badge-table-input.scss?vue&type=style&index=0&id=2c5074b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5074b4",
  null
  
)

export default component.exports